
export * from '../../../frontend-js-react-web/__liferay__/exports/react.js';

import __default__ from '../../../frontend-js-react-web/__liferay__/exports/react.js';
export default __default__;
